import { createContext } from 'react'

const defaultState = {}

export default createContext(defaultState)

export { defaultState }
